export const statusOptions = [
    { id: 1, value: 'Active' },
    { id: 0, value: 'Inactive' }
];

export const formFields = {
    platform: {
        key: 'platform',
        type: 'text',
        label: 'Platform',
        placeholder: 'Select One',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        labelLayout: 'col-md-12',
        tooltip: '<div>Platform</div>',
        valueKey: 'key',
        textKey: 'value'
    },
    country: {
        key: 'country',
        type: 'text',
        label: 'Countries',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        labelLayout: 'col-md-12',
        tooltip: '<div>Countries</div>',
        valueKey: 'id',
        textKey: 'countryName'
    },
    platformFee: {
        key: 'platformFee',
        type: 'number',
        label: 'Platform Margin %',
        labelLayout: 'col-sm-12',
        placeholder: '',
        required: false,
        requiredMessage: 'This field is required.',
        minLength: 0,
        minMessage: 'Minimum value is 0.',
        maxLength: 5,
        maxMessage: 'Maximum value is 99.99',
        min: 0,
        max: 99.99,
        step: 0.01,
        upto2Digit: true,
        displayLayout: 'col-md-12',
        tooltip: '<div> Target Value </div>',
        addBreakOptional: false
    },
    accessToken: {
        key: 'accessToken',
        label: 'Access Token',
        labelLayout: 'col-sm-12',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '',
        addBreakOptional: false
    },
    status: {
        key: 'status',
        label: 'Status',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        labelLayout: 'col-md-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
    },
    accountId: {
        key: 'accountId',
        label: 'Account Id',
        labelLayout: 'col-sm-5',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Account Id</div>',
        valueKey: 'key',
        textKey: 'value'
    },
    subAccountId: {
        key: 'subAccountId',
        label: 'Sub Account Id',
        labelLayout: 'col-sm-8 text-left',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Sub Account Id</div>',
        valueKey: 'key',
        textKey: 'value'
    },
    displayAccountName: {
        key: 'displayAccountName',
        label: 'Display Account Name',
        labelLayout: 'col-sm-12 text-left',
        placeholder: '',
        required: false,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Display Account Name</div>',
        addBreakOptional: false
    },
    accessAccount: {
        key: 'accessAccount',
        label: 'Select Advertisers',
        labelLayout: 'col-sm-9',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        valueKey: 'tenantId',
        textKey: 'tenantName'
    },
    metaBusinessAccountType: {
        key: 'metaBusinessAccountType',
        label: 'Business Account Type',
        labelLayout: 'col-sm-9',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        options: [
            { id: 1, value: 'Business Manager' },
            { id: 0, value: 'Account Manager' }
        ]
    }
};

export const platformConfig = {
    google: "Google Ads",
    beki: "beki",
    ion: "ION",
    viads: 'ViAds',
    meta: "Meta",
    dv360: "DV360",
    tiktok: "TikTok",
    ioh: 'IOH'
};

export const nativePlatforms = ["ion", "viads", "ioh"];

export const platformDisclaimer = {
    [platformConfig.google]: {
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet incidunt ea hic quisquam. Dolor rem sed cupiditate blanditiis recusandae debitis nesciunt quas eaque enim, placeat optio reiciendis autem nemo in!",
        supported: false,
    },
    [platformConfig.meta]: {
        text: "<p>To connect your Meta account, it is essential that your Business Manager and relevant pages grant Infomo full access. For detailed instructions on how to provide access, please refer to this <a href='https://stagecdn.torcai.com/Document-beki/BekiSeatOnboardingDocument_Meta.pdf' target='_blank' style='color: rgb(56, 56, 144)'>link</a>.</p>",
        supported: true,
    },
    [platformConfig.dv360]: {
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet incidunt ea hic quisquam. Dolor rem sed cupiditate blanditiis recusandae debitis nesciunt quas eaque enim, placeat optio reiciendis autem nemo in!",
        supported: false,
    },
    [platformConfig.ion]: {
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet incidunt ea hic quisquam. Dolor rem sed cupiditate blanditiis recusandae debitis nesciunt quas eaque enim, placeat optio reiciendis autem nemo in!",
        supported: false,
    },
    [platformConfig.viads]: {
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet incidunt ea hic quisquam. Dolor rem sed cupiditate blanditiis recusandae debitis nesciunt quas eaque enim, placeat optio reiciendis autem nemo in!",
        supported: false,
    },
    [platformConfig.ioh]: {
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet incidunt ea hic quisquam. Dolor rem sed cupiditate blanditiis recusandae debitis nesciunt quas eaque enim, placeat optio reiciendis autem nemo in!",
        supported: false,
    },
    [platformConfig.tiktok]: {
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet incidunt ea hic quisquam. Dolor rem sed cupiditate blanditiis recusandae debitis nesciunt quas eaque enim, placeat optio reiciendis autem nemo in!",
        supported: false,
    }
};
